// Shared helpers for the Sales CRM + Service Calls screens.

export const TEMPERATURE_ORDER = { hot: 0, warm: 1, cold: 2 };

export const STATUS_LABELS = {
    lead: "Lead",
    in_progress: "In Progress",
    confirmed: "Confirmed",
    client: "Active Client",
    lost: "Lost",
};

export const OUTCOME_LABELS = {
    no_answer: "No Answer",
    call_back_later: "Call Back Later",
    requested_demo: "Requested Demo",
    demo_installed: "Demo Installed",
    not_interested: "Not Interested",
    confirmed: "Confirmed",
    payment_reminder: "Payment Reminder",
    service: "Service Call",
    other: "Other",
};

export function formatDate(d) {
    if (!d) return "—";
    const date = new Date(d);
    if (isNaN(date)) return "—";
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(d) {
    if (!d) return "—";
    const date = new Date(d);
    if (isNaN(date)) return "—";
    return date.toLocaleString("en-IN", {
        day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
}

export function formatDuration(seconds) {
    const s = Number(seconds) || 0;
    const m = Math.floor(s / 60);
    const rem = s % 60;
    if (m === 0) return `${rem}s`;
    return `${m}m ${rem}s`;
}

// "Valid for next 2 months and 7 days" / "Expires today" / "Expired 5 days ago"
export function formatAmcStatus(amcDateStr) {
    if (!amcDateStr) return { text: "Not set", urgency: "none" };

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const amc = new Date(amcDateStr);
    amc.setHours(0, 0, 0, 0);

    if (isNaN(amc)) return { text: "Not set", urgency: "none" };

    const diffDays = Math.round((amc - today) / 86400000);

    if (diffDays < 0) {
        const days = Math.abs(diffDays);
        return { text: `Expired ${days} day${days !== 1 ? "s" : ""} ago`, urgency: "expired" };
    }
    if (diffDays === 0) return { text: "Expires today", urgency: "critical" };

    let months = 0;
    let cursor = new Date(today);
    while (true) {
        const next = new Date(cursor);
        next.setMonth(next.getMonth() + 1);
        if (next <= amc) {
            months++;
            cursor = next;
        } else break;
    }
    const days = Math.round((amc - cursor) / 86400000);
    const parts = [];
    if (months > 0) parts.push(`${months} month${months !== 1 ? "s" : ""}`);
    parts.push(`${days} day${days !== 1 ? "s" : ""}`);

    const urgency = diffDays <= 7 ? "critical" : diffDays <= 30 ? "warning" : "ok";
    return { text: `Valid for next ${parts.join(" and ")}`, urgency };
}

// Sort helper: earliest date first, then hot > warm > cold within the same date.
export function sortCallQueue(items) {
    return [...items].sort((a, b) => {
        const dateDiff = new Date(a.date) - new Date(b.date);
        if (dateDiff !== 0) return dateDiff;
        return (TEMPERATURE_ORDER[a.temperature] ?? 3) - (TEMPERATURE_ORDER[b.temperature] ?? 3);
    });
}